import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";

export class REReelAreaView extends ReelAreaView {

    private _tintGfx: PIXI.Graphics;
    private _isTintVisible: boolean = false;

    constructor() {
        super();
    }

    protected addBaseEventListeners(): void {
        super.addBaseEventListeners();
        //EventHandler.addEventListener(this, RomanEmpireEvents.ON_GOLDEN_GENIE_HANDOVER_START, () => this.onGoldenGenieHandover(true));
        //EventHandler.addEventListener(this, RomanEmpireEvents.ON_GOLDEN_GENIE_HANDOVER_END, () => this.onGoldenGenieHandover(false));
        //EventHandler.addEventListener(this, RomanEmpireEvents.ON_FINAL_MULTIPLIER_MOVE_START, () => this.onGoldenGenieHandover(true));
        //EventHandler.addEventListener(this, RomanEmpireEvents.ON_FINAL_MULTIPLIER_MOVE_END, () => this.onGoldenGenieHandover(false));
    }

    private onGoldenGenieHandover(isStart: boolean) {
        this._isTintVisible = isStart;
        this._tintGfx && (this._tintGfx.visible = this._isTintVisible);
    }

    protected UpdateReelAreaMask(): void {
        super.UpdateReelAreaMask();
        // if (this._tintGfx) {
        //     this.removeChild(this._tintGfx);
        // }
        // const rect: PIXI.Rectangle = GameConfig.instance.REEL_AREA_MASK_RECT != undefined ? GameConfig.instance.REEL_AREA_MASK_RECT :
        //     new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y,
        //         GameConfig.instance.REEL_AREA_WIDTH, GameConfig.instance.REEL_AREA_HEIGHT);
        // this._tintGfx = new PIXI.Graphics();
        // this._tintGfx.beginFill(0x000000, 0.6);
        // this._tintGfx.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height);
        // this._tintGfx.endFill();
        // this._tintGfx.tint = 0x555555;
        // this.addChild(this._tintGfx);
        // this._tintGfx.visible = this._isTintVisible;
    }
}